import { LookupTablesApiParameters, SearchFilters } from "../types/v1_schemas";
// require('dotenv').config()

const urlKey = process.env.REACT_APP_BASE_URL ?? "";
const pathKey = process.env.REACT_APP_URL_PATH ?? "";

const baseURL = urlKey + pathKey;

export const getUrl = (searchFilters?: SearchFilters): string => {
  const filters = {
    ...searchFilters,
  };

  //  https://stackoverflow.com/questions/65565232/how-to-pass-data-using-usecontext-hook

  let urlQueryArgs = [];

  if (filters.page) {
    urlQueryArgs.push("page=" + filters.page);
  }

  if (filters.pageSize) {
    urlQueryArgs.push("pageSize=" + filters.pageSize);
  }

  if (filters.language) {
    urlQueryArgs.push("language=" + filters.language);
  }

  // Provider Name option
  if (filters.displayNameFilter) {
    urlQueryArgs.push("displayNameFilter=" + filters.displayNameFilter);
  }

  // Accessibility options
  if (filters.accessibilitySupportIds) {
    // swagger example
    // https://api.dev.profile.cocaredirectory.com/v1?page=1&pageSize=10&language=en&AccessibilitySupportIds=10160002&AccessibilitySupportIds=10160003&AccessibilitySupportIds=10160004&DistanceSearchZipCode=80120&DistanceSearchRadiusInMiles=25
    filters.accessibilitySupportIds.forEach((option) => {
      urlQueryArgs.push("AccessibilitySupportIds=" + option);
    });
  }

  // Language Id options
  if (filters.languageIds) {
    // swagger example
    // https://api.dev.profile.cocaredirectory.com/v1?page=1&pageSize=10&language=en&LanguageIds=10200001&LanguageIds=10200002&DistanceSearchZipCode=80120&DistanceSearchRadiusInMiles=25
    filters.languageIds.forEach((option) => {
      urlQueryArgs.push("LanguageIds=" + option);
    });
  }

  // Patient Age Group options
  // NOTE: V1Clinic does not contain age group information and cannot be selected by these values
  if (filters.patientAgeGroupIds) {
    // swagger example
    // https://api.dev.profile.cocaredirectory.com/v1?page=1&pageSize=10&language=en&PatientAgeGroupIds=10180001&PatientAgeGroupIds=10180006&DistanceSearchZipCode=80120&DistanceSearchRadiusInMiles=25
    filters.patientAgeGroupIds.forEach((option) => {
      urlQueryArgs.push("PatientAgeGroupIds=" + option);
    });
  }

  // Patient community options
  if (filters.patientCommunityIds) {
    // swagger example
    // https://api.dev.profile.cocaredirectory.com/v1?page=1&pageSize=10&language=en&PatientCommunityIds=10220001&PatientCommunityIds=10220002&PatientCommunityIds=10220003&DistanceSearchZipCode=80120&DistanceSearchRadiusInMiles=25
    filters.patientCommunityIds.forEach((option) => {
      urlQueryArgs.push("PatientCommunityIds=" + option);
    });
  }

  // Payment type options
  if (filters.paymentTypeIds) {
    // swagger example
    // https://api.dev.profile.cocaredirectory.com/v1?page=1&pageSize=10&language=en&PaymentTypeIds=10170001&PaymentTypeIds=10170002&DistanceSearchZipCode=80120&DistanceSearchRadiusInMiles=25
    filters.paymentTypeIds.forEach((option) => {
      urlQueryArgs.push("PaymentTypeIds=" + option);
    });
  }

  // Service Category options
  if (filters.serviceCategoryIds) {
    // swagger example
    // https://api.dev.profile.cocaredirectory.com/v1?page=1&pageSize=10&language=en&ServiceCategoryIds=1500102&ServiceCategoryIds=1500101&ServiceCategoryIds=1500103&DistanceSearchZipCode=80120&DistanceSearchRadiusInMiles=25
    filters.serviceCategoryIds.forEach((option) => {
      urlQueryArgs.push("ServiceCategoryIds=" + option);
    });
  }

  // Telehealth
  if (filters.telehealthOptions) {
    // swagger example
    // https://api.dev.profile.cocaredirectory.com/v1?page=1&pageSize=10&language=en&TelehealthOptionTypes=both&TelehealthOptionTypes=only&DistanceSearchZipCode=80120&DistanceSearchRadiusInMiles=25
    filters.telehealthOptions.forEach((option) => {
      urlQueryArgs.push("TelehealthOptionTypes=" + option);
    })
  }

  // Hours options
  // swagger example
  // https://api.dev.profile.cocaredirectory.com/v1?page=1&pageSize=10&language=en&OpenSunday=true&OpenMonday=true&OpenTuesday=true&OpenWednesday=true&OpenThursday=true&OpenFriday=true&OpenSaturday=true&DistanceSearchZipCode=80120&DistanceSearchRadiusInMiles=25

  if (filters.openSunday) {
    urlQueryArgs.push("OpenSunday=true");
  }

  if (filters.openMonday) {
    urlQueryArgs.push("OpenMonday=true");
  }

  if (filters.openTuesday) {
    urlQueryArgs.push("OpenTuesday=true");
  }

  if (filters.openWednesday) {
    urlQueryArgs.push("OpenWednesday=true");
  }

  if (filters.openThursday) {
    urlQueryArgs.push("OpenThursday=true");
  }

  if (filters.openFriday) {
    urlQueryArgs.push("OpenFriday=true");
  }

  if (filters.openSaturday) {
    urlQueryArgs.push("OpenSaturday=true");
  }

  if (filters.openSaturday) {
    urlQueryArgs.push("OpenSaturday=true");
  }

  if (filters.distanceSearchZipCode) {
    urlQueryArgs.push("distanceSearchZipCode=" + filters.distanceSearchZipCode);
  }

  if (filters.distanceSearchRadiusInMiles) {
    urlQueryArgs.push("distanceSearchRadiusInMiles=" + filters.distanceSearchRadiusInMiles);
  }
  
  let pathKey;
  pathKey  = process.env.REACT_APP_URL_PATH ?? "";

  const baseURL = urlKey + pathKey;

  if (urlQueryArgs.length) {
    return baseURL + "?" + urlQueryArgs.join("&");
  } else return baseURL;
};

// id can be the clinic id or the account id
export const getSingleUrl = (id : string, lang: string = "en"): string => {
  
  let pathKey;
  pathKey  = process.env.REACT_APP_URL_PATH ?? "";

  const baseURL = urlKey + pathKey;

  return baseURL + "/" + id + "?language=" + lang;
};

export const getTablesUrl = (params: LookupTablesApiParameters): string => {
  
  let urlQueryArgs = [];

  if (params.language){
    urlQueryArgs.push("language=" + params.language);
  }

  if (params.language){
    urlQueryArgs.push("language=" + params.language);
  }

  if (params.IncludeAccessibilitySupports){
    urlQueryArgs.push("IncludeAccessibilitySupports=" + params.IncludeAccessibilitySupports);
  }

  if (params.IncludeCareSettings){
    urlQueryArgs.push("IncludeCareSettings=" + params.IncludeCareSettings);
  }

  if (params.IncludeLanguages){
    urlQueryArgs.push("IncludeLanguages=" + params.IncludeLanguages);
  }

  if (params.IncludePatientAgeGroups){
    urlQueryArgs.push("IncludePatientAgeGroups=" + params.IncludePatientAgeGroups);
  }

  if (params.IncludePatientCommunities){
    urlQueryArgs.push("IncludePatientCommunities=" + params.IncludePatientCommunities);
  }

  if (params.IncludePaymentTypes){
    urlQueryArgs.push("IncludePaymentTypes=" + params.IncludePaymentTypes);
  }

  if (params.IncludeRaes){
    urlQueryArgs.push("IncludeRaes=" + params.IncludeRaes);
  }

  if (params.IncludeServiceCategories){
    urlQueryArgs.push("IncludeServiceCategories=" + params.IncludeServiceCategories);
  }

  if (params.IncludeServicesProvided){
    urlQueryArgs.push("IncludeServicesProvided=" + params.IncludeServicesProvided);
  }

  if (params.IncludeTelehealthOptions){
    urlQueryArgs.push("IncludeTelehealthOptions=" + params.IncludeTelehealthOptions);
  }

  if (urlQueryArgs.length) {
    return baseURL + "/lookup-tables?" + urlQueryArgs.join("&");
  } else return baseURL + "/lookup-tables";
};